import { Row, Col, Typography, Checkbox } from 'antd';
import React from 'react';

const { Text } = Typography;

const QualifyingQuestionFilter = ({ filterOptions, filterValues = {}, handleFilterChange }) => {
  const questionList = filterOptions?.questionList || [];

  // Helper function to decode HTML entities
  const decodeHtmlEntities = (text) => {
    if (!text) return text;
    const textArea = document.createElement('textarea');
    textArea.innerHTML = text;
    return textArea.value;
  };

  const transformQuestions = (questionList) => {
    return questionList.map((q, index) => ({
      id: q.id || index,
      question: decodeHtmlEntities(q.question),
      options: (q.options || []).map(option => decodeHtmlEntities(option)),
      answer: Array.isArray(q.correct_answer)
        ? q.correct_answer.map(ans => decodeHtmlEntities(ans))
        : q.correct_answer
        ? [decodeHtmlEntities(q.correct_answer)]
        : [],
      mandatory: q.mandatory || false,
      mixup: q.mixup || false,
    }));
  };

  const questions = transformQuestions(questionList);

  // Use array of { questionId, options }
  const selectedQualifyingQuestions = filterValues.selectedQualifyingQuestions || [];

  const handleChange = (questionId, option) => {
    let updated = [...selectedQualifyingQuestions];

    const existingIndex = updated.findIndex((q) => q.questionId === questionId);

    if (existingIndex !== -1) {
      const existing = updated[existingIndex];
      const isSelected = existing.options.includes(option);

      const newOptions = isSelected
        ? existing.options.filter((o) => o !== option)
        : [...existing.options, option];

      if (newOptions.length === 0) {
        updated.splice(existingIndex, 1); // remove question entry
      } else {
        updated[existingIndex] = {
          questionId,
          options: newOptions,
        };
      }
    } else {
      updated.push({
        questionId,
        options: [option],
      });
    }

    handleFilterChange(updated, 'selectedQualifyingQuestions');
  };

  return (
    <Row gutter={[16, 16]} style={{ padding: '10px' }}>
      <Col span={24}>
        <Text style={{ fontSize: '14px', color: '#4D566E' }}>
          Select your preferred answers for Qualifying Questions
        </Text>
        <br />
        <Text style={{ fontSize: '12px', color: 'rgba(77, 86, 110, 0.5)' }}>
          (The answers marked in green are preferred for the role)
        </Text>
      </Col>

      {questions.map((item, index) => {
        const foundQuestion = selectedQualifyingQuestions.find((q) => q.questionId === item.id);

        return (
          <Col key={item.id} span={24} style={{ padding: '12px', borderRadius: '8px' }}>
            <Text strong style={{ display: 'block', marginBottom: 8 }}>
              {index + 1}. {item.question}
            </Text>
            <div style={{ marginTop: '8px' }}>
              {item.options.map((option, idx) => {
                const isCorrect = item.answer.some(
                  (ans) => ans.trim().toUpperCase() === option.trim().toUpperCase()
                );

                const isChecked = foundQuestion?.options?.includes(option) || false;

                return (
                  <div key={idx} style={{ marginBottom: 4 }}>
                    <Checkbox
                      checked={isChecked}
                      onChange={() => handleChange(item.id, option)}
                    />
                    <Text
                      style={{
                        marginLeft: 8,
                        color: isCorrect ? '#0FB680' : '#000',
                      }}
                    >
                      {option}
                    </Text>
                  </div>
                );
              })}
            </div>
          </Col>
        );
      })}
    </Row>
  );
};

export default QualifyingQuestionFilter;
